import { Card, Divider, Grid, Stack, Typography } from '@mui/material'
import React from 'react'

function CompareItems({items, removeItem}) {
  return (
    <div>
    <Typography variant='h6'>Compare items</Typography><br/>
    <Grid container spacing={2}>
        {items?.map((i, index)=>(
            <Grid item xs={6} md={6} key={index}>
                <Card sx={{p:2}}>
                <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant='h5'>{i.name}</Typography>
            <Typography  onClick={()=>removeItem(i.id)}>X</Typography>
            </Stack>
            <Divider sx={{my:2}} />
            <Typography variant='h6' sx={{mb:2}}><Typography component={"span"}>Category</Typography><br/>{i.category}</Typography>
            <Typography variant='h6' sx={{mb:2}}><Typography component={"span"}>Condition</Typography><br/>{i.condition}</Typography>
            <Typography variant='h6' sx={{mb:2}}><Typography component={"span"}>Description</Typography><br/>{i.description}</Typography>
            <Typography variant='h6' sx={{mb:2}}><Typography component={"span"}>Location</Typography><br/>{i.location}</Typography>
            <Typography variant='h6' sx={{mb:2}}><Typography component={"span"}>Price</Typography><br/>{i.price}</Typography>
            <Typography variant='h6' sx={{mb:2}}><Typography component={"span"}>Type</Typography><br/>{i.type}</Typography>
                </Card>
            </Grid>
        ))}
    </Grid>
    </div>
  )
}

export default CompareItems